import type { ReactNode } from 'react';

interface MobileFrameProps {
  children: ReactNode;
}

/**
 * Wrapper de 100dvh com grid de 2 linhas: conteúdo / tab-bar.
 * Respeita o safe-area-inset-top do iOS (notch/dynamic island)
 * sem renderizar uma status bar própria — o status real do sistema fica visível.
 */
export function MobileFrame({ children }: MobileFrameProps) {
  return (
    <div
      style={{
        width: '100%',
        height: '100dvh',
        display: 'grid',
        gridTemplateRows: '1fr auto',
        background: 'var(--bg)',
        overflow: 'hidden',
        position: 'relative',
        paddingTop: 'env(safe-area-inset-top, 0px)',
      }}
    >
      {children}
    </div>
  );
}
